import { render, staticRenderFns } from "./ContentResourcesWizard.vue?vue&type=template&id=65a41402&"
import script from "./ContentResourcesWizard.vue?vue&type=script&lang=ts&"
export * from "./ContentResourcesWizard.vue?vue&type=script&lang=ts&"
import style0 from "./ContentResourcesWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports